const regex = /(<([^>]+)>)/gi;

export const excerpt = (str, count = 200) => {
  if (!str) return "";

  return str.replace(regex, "").substring(0, count) + "...";
};